import { useEffect } from 'react';
import { Router } from 'next/router';
import AnalyticsManager from '@lib/analytics/manager';
import { CustomerIOManager } from '@lib/analytics/customerIO';

export const TrackPageView = () => {
  useEffect(() => {
    function trackPage(url) {
      AnalyticsManager().trackPage(url);
      CustomerIOManager.trackPage();
    }

    Router.events.on('routeChangeComplete', trackPage);
    window.addEventListener('beforeunload', removeEventListeners);

    function removeEventListeners() {
      Router.events.off('routeChangeComplete', trackPage);
      window.removeEventListener('beforeunload', removeEventListeners);
    }

    return removeEventListeners;
  }, []);

  return null;
};
